import { TZDateFunct, MS_X_DAY, MS_X_HOUR } from '@/utils/ZDateFunct.js'

export const SCALE_SUGGERITE = [  
                                  3,5,
                                  10,20,30,40,50,60,70,80,90,
                                  100,200,300,400,500,600,700,800,900,
                                  1000,2000,3000,4000,5000,6000,7000,8000,9000,10000 
                               ];

export class TInfoGraphic
{
  static GetAdjustedNotchDim(NotchDim, Divisore)
  {
    // if(NotchDim <= TZDateFunct.GetNHoursInTimeStamp(1.5))
    //   return TZDateFunct.GetNHoursInTimeStamp(1)

    // if(NotchDim <= TZDateFunct.GetNHoursInTimeStamp(2.5))
    //   return TZDateFunct.GetNHoursInTimeStamp(2)
          
    // if(NotchDim <= TZDateFunct.GetNHoursInTimeStamp(3.5))
    //   return TZDateFunct.GetNHoursInTimeStamp(3)

    // if(NotchDim <= TZDateFunct.GetNHoursInTimeStamp(5))
    //   return TZDateFunct.GetNHoursInTimeStamp(4)

    // if(NotchDim <= TZDateFunct.GetNHoursInTimeStamp(7))
    //   return TZDateFunct.GetNHoursInTimeStamp(6)

    // if(NotchDim <= TZDateFunct.GetNHoursInTimeStamp(16))
    //   return TZDateFunct.GetNHoursInTimeStamp(8)

    if(NotchDim <= TZDateFunct.GetNHoursInTimeStamp(24))
      return TZDateFunct.GetNHoursInTimeStamp(1)

    if(NotchDim <= MS_X_DAY)
      return MS_X_DAY

    if(NotchDim % Divisore != 0)
      NotchDim = (NotchDim - (NotchDim % Divisore))

    NotchDim = NotchDim / Divisore
    NotchDim = Math.ceil(NotchDim / MS_X_HOUR) * MS_X_HOUR

    return NotchDim 
  }

  static ChooseScale(MaxScala)
  {
    let Result = MaxScala

    for(let i = 0; i < SCALE_SUGGERITE.length; i++)
      if(SCALE_SUGGERITE[i] > MaxScala)
      {
        Result = SCALE_SUGGERITE[i]
        break;
      }

    return Result
  }
}